import { FormHelperText } from '@mui/material';
import { isEmpty } from 'lodash-es';
import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import MessengerInput from './MessengerInput';

interface IControlledMessengerInput {
  name: string;
  labelText?: string;
}

const ControlledMessengerInput: FC<IControlledMessengerInput> = ({ name, labelText }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <>
          <MessengerInput
            initialValue={!isEmpty(value) ? value : [{ type: '', messengerId: '' }]}
            onInputChange={onChange}
            labelText={labelText}
          />
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
};

export default ControlledMessengerInput;
